/*
 * View for the standard responses list
 */

define([
  "marionette",
  "modules/topicsSplit/topics/standardResponsesList/template/standardResponsesListTemplate.html",
], function (Marionette, StandardResponsesListTemplate) {
  var StandardResponsesListView = {};

  StandardResponsesListView.standardResponsesListLayout = Marionette.Layout.extend({
    template: StandardResponsesListTemplate,
    closeStatusMenu: function () {
      this.$el.find(".btn-group").removeClass("open");
    },
    events: {
      "click #standardResponseDropdown": function () {
        //use event instead of trigger to avoid blocking the propogation of this event
        //if we are opening the change status menu, trigger the event and generate menu listing
        if (!this.$el.find(".btn-group").hasClass("open")) {
          //since the menu will show up even if we don't want it to, hide it until we are sure we want to show the menu
          this.$el.find("#standardResponseDropdownMenu").addClass("hidden");
          this.trigger("open:topic:status:menu");
        }
      },
    },
    regions: {
      list: "#list",
    },
    clearError: function () {
      this.$el.find("#standardResponsesError").html("");
    },
    standardResponsesError: function (errorMessage) {
      this.$el
        .find("#standardResponsesError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    showStatusMenu: function () {
      this.$el.find("#standardResponseDropdownMenu").removeClass("hidden");
    },
    triggers: {
      "click #publishStandardResponse": "publish",
    },
  });

  return StandardResponsesListView;
});
